<template>
  <b-card>
    <FormBuilder
      label="Voucher"
      update
      :data="$store.state.voucher.detailData"
      :fields="fields"
      :loading-detail="$store.state.voucher.loadingDetail"
      :loading-submit="$store.state.voucher.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/voucher'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('voucher/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('voucher/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('voucher/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
